import { Box } from "@chakra-ui/layout";
import { useStyleConfig } from "@chakra-ui/system";

export const SkipLink = () => (
  <Box as="a" sx={useStyleConfig("SkipLink")} href="#skip-nav">
    Skip to content
  </Box>
);
